// Shared countdown timer (Meeting Tools). Like polls/chat, it rides the E2EE
// data channel — the SFU sees only ciphertext. Host-authoritative and, crucially,
// it is NOT ticked over the wire: the host broadcasts a message only on a state
// CHANGE (start / pause / resume / reset / stop / done), carrying the remaining
// ms at that moment; every client counts down locally, anchored to when it
// received the message (so machine clock skew is irrelevant). A whole timed run
// is a handful of messages, not one per second. Ephemeral — nothing persists.

export const TIMER_TOPIC = 'bz.timer';

export type TimerWire =
  | { t: 'state'; status: 'running' | 'paused' | 'done'; remainingMs: number; durationMs: number }
  | { t: 'clear' };

const encoder = new TextEncoder();
const decoder = new TextDecoder();
const MAX_MS = 24 * 60 * 60 * 1000; // 24h ceiling, bound defensively

export function encodeTimer(w: TimerWire): Uint8Array<ArrayBuffer> {
  return new Uint8Array(encoder.encode(JSON.stringify(w)));
}

export function decodeTimer(payload: Uint8Array): TimerWire | null {
  try {
    const w = JSON.parse(decoder.decode(payload)) as TimerWire;
    if (w?.t === 'clear') return { t: 'clear' };
    if (
      w?.t === 'state' &&
      (w.status === 'running' || w.status === 'paused' || w.status === 'done')
    ) {
      return {
        t: 'state',
        status: w.status,
        remainingMs: Math.max(0, Math.min(MAX_MS, Number(w.remainingMs) || 0)),
        durationMs: Math.max(0, Math.min(MAX_MS, Number(w.durationMs) || 0)),
      };
    }
    return null;
  } catch {
    return null;
  }
}
